require('../vendor/jquery.ui/widget');
require('../vendor/jquery.ui/widgets/mouse');
require('../vendor/jquery.ui/core');
require('../vendor/jquery.ui/position');
require('../vendor/jquery.ui/widgets/draggable');
require('../vendor/jquery.ui/widgets/droppable');
require('../vendor/jquery.ui/widgets/sortable');
